import { makeAutoObservable } from "mobx";
import {
  pagingPatientSync,
} from "app/services/PatientService";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import { PAGESIZE_ALL, PathModule } from "app/common/LocalConst";
import { pagingVisitType } from "app/services/VisitTypeService";
import { syncListPatientToCrm } from "app/services/SyncCRMService";

export default class PatientAsyncStore {
  searchPatient = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  selectPatientAsync = [];
  resetSelectedRows = false;
  pagePatient = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingPatient = async () => {
    const { departmentId, ...ortherData } = this.searchPatient;
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }

    return await pagingPatientSync({ ...ortherData })
      .then(({ data }) => {
        this.pagePatient = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchPatient) => {
    this.searchPatient = { ...this.searchPatient, ...searchPatient };

    this.pagingPatient();
  };

  getVisitType = async () => {
    return await pagingVisitType({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: "offline_checkin",
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          return data?.content?.[0];
        }
        return null;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu loại check in có lỗi");
      });
  };

  setSelectPatientAsync = (list) => {
    this.selectPatientAsync = list;
  };

  syncListPatientToCrm = async () => {
    const patientIds = this.selectPatientAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncListPatientToCrm({ patientIds })
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ khách hàng thành công");
          this.pagingPatient();
        } else {
          toast.error("Đồng bộ khách hàng có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error(error);
        toast.error("Đồng bộ khách hàng có lỗi");
      });
  };

  resetStore = () => {
    this.searchPatient = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
  };
}
